import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import { StackPullRequestsTablePullRequestCellProps } from "../types";

const StackPullRequestsTablePullRequestActionsCell = (
  props: StackPullRequestsTablePullRequestCellProps
) => {
  return (
    <TableSimpleCell {...props}>
      <TableCellEmpty />
    </TableSimpleCell>
  );
};

export default StackPullRequestsTablePullRequestActionsCell;
